import { Box, Theme, Typography, useMediaQuery } from "@mui/material";
import { List, SearchInput, useListContext, TopToolbar, FilterButton, SortButton, useGetResourceLabel, TextInput, useTranslate, BooleanInput } from "react-admin";
import MobileGrid from "./MobileGrid";
import CoreCreateButton from "../../../../shared/components/core/CoreCreateButton";
import { portExporter } from "../../../../shared/utilities/adminExporter";
import SacopExportButton from "../../../../shared/components/core/SacopExportButton";

const ListActions = () => (
    <TopToolbar>
        <CoreCreateButton permission="BACKOFFICE_PORT_C" />
        <SortButton fields={['name']} />
        <FilterButton />
        <SacopExportButton exporter={portExporter} />
    </TopToolbar>
);

const portFilters = [
    <SearchInput source="q" alwaysOn />,
    <BooleanInput source="active" />,
    <TextInput source="name" />
];

const TabbedDatagrid = () => {
    const listContext = useListContext();
    const isXSmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );
    return (
        <MobileGrid  {...listContext} />
    );
}

const PortList = () => {
    return (<List
        filterDefaultValues={ { active: true }}
        sort={{ field: 'name', order: 'DESC' }}
        perPage={25}
        filters={portFilters}
        actions={<ListActions />}
        exporter={portExporter}
    >
        <TabbedDatagrid />
    </List>);
};

export default PortList;
